<template>
    <a-layout class="container">
        <!-- 左侧区域 -->
        <hina-base-slider :currentMenuKey="curMenuKey" :currentOpenKey="curOpenKey" />
        <!-- 主体区域 -->
        <a-layout>
            <!-- 头部 -->
            <hina-user-info :user="objUserInfo" />

            <a-layout-content>
                <!-- 位置 -->
                <hina-bread-crumb :link="arrBreadLink" />

                <div class="wrapper">
                    <div class="wrap">
                        <div class="hd">
                            <div class="filter">
                                <div class="title">年优惠码</div>
                                <div class="query">
                                    <!-- <div class="query-item">
                                        <a-dropdown-button>
                                            查询方式
                                            <a-menu slot="overlay" @click="handleMenuClick" style="line-height: 48px">
                                                <a-menu-item key="1">
                                                    <a-space v-if="strQueryType == '姓名'"
                                                        style="color: #45a3ff">按姓名查询</a-space>
                                                    <a-space v-else>按姓名查询</a-space>
                                                </a-menu-item>
                                            </a-menu>
                                            <a-icon slot="icon" type="user" />
                                        </a-dropdown-button>
                                    </div>
                                    <div class="query-item">
                                        <a-input v-model="queryParams" @keyup.enter="loadStaffList" type="text" />
                                    </div>
                                    <div class="query-item">
                                        <a-button @click="loadStaffList" type="primary">查询</a-button>
                                    </div> -->

                                </div>
                            </div>
                        </div>
                        <div class="trans-table">
                            <a-table :columns="columns" :row-key="(record) => record.id" :data-source="data"
                                :pagination="pagination" :loading="loading" @change="handleTableChange">
                                <!-- <div slot="code" slot-scope="text, record,index">
                                    <vue-qr :id="index + 'payQr'" :text="record.codes" :size="110" :correctLevel="3"
                                        :margin="30" :callback="getImgInfo"
                                        style="background-color: white;opacity:1"></vue-qr>
                                </div> -->
                                <template slot="action" slot-scope="text, record">
                                    <a href="javascript:;" @click="review(record)">查看</a>
                                </template>
                            </a-table>
                        </div>
                    </div>
                </div>
            </a-layout-content>
            <a-modal v-model="codeDetail" title="优惠码详情" :width="1240" :centered="true"
                :okButtonProps="{ style: { display: 'none' } }" cancelText="取消">
                <a-table bordered :columns="codeColumns" :data-source="codeData" :row-key="(record) => record.id"
                    :pagination="paginationCode" @change="handleTableCodeChange">
                </a-table>
            </a-modal>
        </a-layout>
    </a-layout>
</template>

<script>
import HinaBaseSlider from 'components/HinaBaseSlider/HinaBaseSlider'
import HinaUserInfo from 'components/HinaUserInfo/HinaUserInfo'
import HinaBreadCrumb from 'components/HinaBreadCrumb/HinaBreadCrumb'
import vueQr from 'vue-qr'
import locale from 'ant-design-vue/lib/date-picker/locale/zh_CN'

export default {
    name: 'Profile',
    components: {
        HinaBaseSlider,
        HinaUserInfo,
        HinaBreadCrumb,
        vueQr
    },
    data() {
        return {
            locale,
            frmAllocation: {},
            objUserInfo: {},
            curMenuKey: ['discountCode'],
            curOpenKey: ['sub5'],
            arrBreadLink: [],
            color: 'error',
            loading: false,
            strQueryType: '姓名',
            queryParams: '',
            data: [],
            columns: [
                {
                    title: '优惠码',
                    dataIndex: 'codes',
                    align: 'center',
                    // scopedSlots: { customRender: 'code' },
                },
                {
                    title: '兑换码',
                    dataIndex: 'code',
                    align: 'center',
                    width: 180
                },
                {
                    title: '总数量',
                    dataIndex: 'count',
                    align: 'center',
                    width: 120
                },
                {
                    title: '使用数量',
                    dataIndex: 'usedCount',
                    align: 'center',
                    width: 120
                },
                {
                    title: '剩余数量',
                    dataIndex: 'surplusCount',
                    align: 'center',
                    width: 120
                },
                {
                    title: '优惠额度',
                    dataIndex: 'money',
                    align: 'center',
                    width: 120
                },
                {
                    title: '到期时间',
                    dataIndex: 'expirationTime',
                    align: 'center',
                    width: 120
                },
                {
                    title: '操作',
                    key: 'action',
                    scopedSlots: { customRender: 'action' },
                    width: 100
                }
            ],
            codeColumns: [

                {
                    title: '使用人',
                    dataIndex: 'userName',
                    align: 'center',
                },
                {
                    title: '用户手机号',
                    dataIndex: 'phone',
                    align: 'center',
                },
                {
                    title: '使用时间',
                    dataIndex: 'useDate',
                    align: 'center',
                },
                {
                    title: '优惠额度',
                    dataIndex: 'money',
                    align: 'center',
                },
            ],
            pagination: {
                pageSize: 10,
                total: 0,
                current: 1
            },
            paginationCode: {
                pageSize: 10,
                total: 0,
                current: 1
            },
            qrIndex: 0,
            codeId: '',
            codeDetail: false,
            codeData: [],
            codeLoading: false

        }
    },

    methods: {

        //查询列表
        loadStaffList() {
            //查询对象
            let params = {
                pageNumber: this.pagination.current,
                pageSize: this.pagination.pageSize
            }
            this.data = []
            this.$get('/couponYard/user/page', params).then((res) => {
                let records = res.result.records
                this.data = records.map(item => {
                    item.codes = 'https://fxinpz.com/wechat/openvip?voucher=' + item.code + '&yearVipCardId=1854429108318138370'
                    item.surplusCount = item.count - item.usedCount
                    return item
                })
                this.pagination = {
                    current: res.result.current,
                    pageSize: res.result.size,
                    total: res.result.total
                }
                this.loading = false
            })
        },
        //查询详情列表
        loadCodeList() {
            //查询对象
            let params = {
                pageNumber: this.paginationCode.current,
                pageSize: this.paginationCode.pageSize
            }
            this.codeData = []
            this.codeLoading = true
            this.$get(`/couponYard/getById/${this.codeId}`, params).then((res) => {
                let records = res.result.records
                this.codeData = records
                this.paginationCode = {
                    current: res.result.current,
                    pageSize: res.result.size,
                    total: res.result.total
                }
                this.codeLoading = false
            }).catch(() => {
                this.codeLoading = false
            })
        },
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current
            this.pagination.pageSize = pagination.pageSize
            this.loading = true
            this.loadStaffList()
        },
        // 详情列表分页功能
        handleTableCodeChange(pagination, filters, sorter) {
            this.paginationCode.current = pagination.current
            this.paginationCode.pageSize = pagination.pageSize
            this.loadCodeList()
        },
        getImgInfo(qrUrl) {
            const img = new Image();
            img.src = qrUrl;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                const text = this.data[this.qrIndex].code;

                canvas.width = img.width;
                canvas.height = img.height;
                console.log(canvas.style)

                ctx.drawImage(img, 0, 0);

                // 设置轮廓颜色和宽度
                ctx.strokeStyle = '#fff';
                ctx.lineWidth = 3;

                // 绘制文字轮廓
                ctx.strokeText(text, canvas.width / 2 - ctx.measureText(text).width / 2, canvas.height / 1.05);

                ctx.font = 'bold 12px'; // 设置字体大小和类
                ctx.fillStyle = 'balck'; // 设置字体颜色
                ctx.globalAlpha = 1;
                ctx.fillText(text, canvas.width / 2 - ctx.measureText(text).width / 2, canvas.height / 1.05); // 在图片中心添加文字

                document.getElementById(this.qrIndex + 'payQr').src = canvas.toDataURL('image/png');
                this.qrIndex++
            };
        },
        review(row) {
            this.codeId = row.id
            this.codeDetail = true
            this.loadCodeList()
        },
    },
    mounted: function () {
        this.objUserInfo = {
            id: this.$store.state.userInfo.id,
            name: this.$store.state.userInfo.enterpriseFullName
        }
        this.arrBreadLink.push({ name: '年优惠码', link: '/discountCode' })
        this.loadStaffList()
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    .wrap {
        margin: 20px 0 0;
        padding: 0 24px;
        background: #fff;
        min-height: 240px;

        .hd {
            height: 72px;
            line-height: 72px;
            color: #333;
            font-weight: 600;
            font-size: 18px;
            position: relative;
            margin-bottom: 30px;

            &::after {
                position: absolute;
                content: '';
                height: 1px;
                background: rgba(0, 0, 0, 0.1);
                left: 0;
                right: 0;
                bottom: 0;
            }

            .filter {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .query {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;

                    .query-item {
                        padding: 0 0 0 5px;
                        height: 48px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }
        }

        .trans-table {
            padding: 0 0 5px;
        }
    }

    .wrap:first-of-type {
        margin: 0;
    }
}

.frm-staff {
    padding: 20px 50px;
    text-align: center;

    .frm-line {
        min-height: 72px;
        padding: 12px 0;
        box-sizing: border-box;

        .lab {
            font-size: 16px;
            line-height: 48px;
            text-align: right;
            position: relative;

            &::after {
                position: relative;
                content: '：';
            }
        }

        .required {
            &::before {
                position: relative;
                content: '*';
                color: red;
                padding: 0 5px 0 0;
            }
        }

        .txt {
            line-height: 48px;
            font-size: 16px;
        }
    }
}
</style>
